import * as Sentry from '@sentry/browser';

export class Crashlytics {
    static captureException(e){
        Sentry.captureException(e)
    }
}